// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DUM-","toggle":"styles_toggle__CQdIo","preview":"styles_preview__34Nes"};